module.exports = __webpack_public_path__ + "static/media/devices.ed225de4.svg";